<template>
  <v-container fluid>
    <v-form ref="form" v-model="valid">
      <v-row>
        <v-col cols="12" xs="12">
          <v-toolbar flat width="100%">
            <v-toolbar-title class="pl-3 banner-title blue--text">
              Create Delivery Order for Voyage no:
              {{ vessel.voyage_number ? vessel.voyage_number : "N/A" }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <div>
              <!--<addVessel class="pr-3" />-->
            </div>
          </v-toolbar>

          <!-- <v-form> -->
          <v-container>
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="do_detail.do_number"
                  label="DO Number"
                  :rules="inputRules"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="do_detail.bl_number"
                  label="BL Number"
                  :rules="inputRules"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="do_detail.consignee_fullname"
                  label="Consignee Fullname"
                  :rules="nameRules"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="do_detail.consignee_address"
                  label="Consignee Address"
                  :rules="addressRules"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="do_detail.consignee_email"
                  :rules="emailRules"
                  label="E-mail"
                  required
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="total_items"
                  label="Number of Items"
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          <!-- </v-form>-->
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" xs="12">
          <v-toolbar flat width="100%">
            <v-toolbar-title class="pl-3 banner-title blue--text">
              Delivery Order Form
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <div>
              <!--<addVessel class="pr-3" />-->
            </div>
          </v-toolbar>

          <!-- <v-form> -->
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="3">
                <v-select
                  v-model="cargo_type"
                  :items="item_type"
                  label="Cargo Type"
                  outlined
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="3" v-if="cargo_type === 'RoRo'">
                <v-select
                  v-model="vehicle_tonnage"
                  :items="tonnage_list"
                  label="Vehicle Tonnage Range"
                  outlined
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="3"
                v-if="cargo_type === 'Full Container'"
              >
                <v-select
                  v-model="cargo_size"
                  :items="items"
                  label="Cargo Size"
                  outlined
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="3"
                v-if="cargo_type === 'Full Container'"
              >
                <v-text-field
                  v-model="cargo_no"
                  label="Cargo Number"
                  placeholder="enter cargo number"
                  :rules="inputRules"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="3"
                v-if="cargo_type === 'Full Container'"
              >
                <v-text-field
                  v-model="seal_number"
                  label="Seal Number"
                  placeholder="enter seal number"
                  type="number"
                  :rules="inputRules"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3" v-if="cargo_type === 'RoRo'">
                <v-text-field
                  v-model="vin_number"
                  label="Vin/Chasi Number"
                  placeholder="enter vehicle vin number"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                v-if="cargo_type === 'Full Container' || cargo_type === 'RoRo'"
              >
                <v-text-field
                  v-model="cargo_description"
                  label="Cargo Description"
                  placeholder="enter cargo description"
                  :rules="textRules"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="3"
                md="2"
                v-if="cargo_type === 'Full Container' || cargo_type === 'RoRo'"
              >
                <v-checkbox
                  v-model="is_transit"
                  :label="`Is Trasit?`"
                ></v-checkbox>
                <!--:label="`Is Trasit?: ${is_transit.toString()}`"-->
              </v-col>
              <v-col
                cols="12"
                sm="3"
                md="2"
                v-if="cargo_type === 'Full Container' || cargo_type === 'RoRo'"
              >
                <v-checkbox
                  v-model="is_reefer"
                  :label="`Is Reefer?`"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" sm="3" md="2" v-if="is_reefer">
                <v-text-field
                  v-model="hrs"
                  label="Plugged Duration"
                  placeholder="enter in hours only"
                  type="number"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="3"
                v-if="cargo_type === 'Full Container' || cargo_type === 'RoRo'"
              >
                <v-btn depressed color="primary" @click="addItemsToDo()">
                  Add Item
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
          <!-- </v-form> -->
        </v-col>
      </v-row>
      <v-col cols="12">
        <v-data-table
          :headers="header"
          item-key="id"
          class="elevation-1"
          :search="search"
          :loading="loading"
          :items="item_list"
        >
          <template v-slot:top>
            <v-text-field
              v-model="search"
              label="Search"
              class="mx-4"
            ></v-text-field>
          </template>
          <template v-slot:[`item.actions`]="item">
            <template>
              <v-icon
                small
                class="mr-2;"
                style="cursor: pointer"
                @click="removeItem(item)"
              >
                mdi-delete
              </v-icon>
            </template>
          </template>
          <template v-slot:item.is_reefer="{ item }">
            <v-icon v-if="item.is_reefer" small>mdi-check-circle</v-icon>
            <v-icon v-if="!item.is_reefer" small>mdi-close-circle</v-icon>
          </template>
          <template v-slot:item.is_transit="{ item }">
            <v-icon v-if="item.is_transit" small>mdi-check-circle</v-icon>
            <v-icon v-if="!item.is_transit" small>mdi-close-circle</v-icon>
          </template>
        </v-data-table>
      </v-col>
      <v-col>
        <v-card class="mx-auto">
          <v-card-text>
            <div>Please input the following:</div>

            <v-row>
              <v-col cols="12" sm="6" md="3">
                <v-text-field
                  v-model="holidays"
                  label="Public Holidays"
                  placeholder="enter in number of days"
                  type="number"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field
                  v-model="weekends"
                  label="Weekends"
                  placeholder="enter in number of days"
                  type="number"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn depressed @click="calculateCharges()">
              Calculate Charges
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col>
        <v-card class="mx-auto">
          <v-card-title>Charges Summary</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="6" md="3">
                Total Items:
              </v-col>
              <v-col cols="12" sm="6" md="3">
                {{ total_items }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="3">
                Days Excluded:
              </v-col>
              <v-col cols="12" sm="6" md="3">
                {{ parseInt(holidays) + parseInt(weekends) }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="3">
                Days spent since
                <span v-if="is_transit" style="font-weight: bold;">
                  {{ vessel.arrival_date | formatShortDate }}</span
                >
                <span v-else style="font-weight: bold;">
                  {{ vessel.departure_date | formatShortDate }}</span
                >:
              </v-col>
              <v-col cols="12" sm="6" md="3">
                {{ total_days_spend }}
              </v-col>
              <v-col cols="12" sm="6" md="3">
                After Excluded Days:
              </v-col>
              <v-col cols="12" sm="6" md="3">
                {{ final_days_spend }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="3">
                Total Charges as of today (GMD):
              </v-col>
              <v-col cols="12" sm="6" md="3">
                {{ total_charges }}
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col>
        <v-card class="mx-auto">
          <v-card-actions class="float-left">
            <v-btn color="default" @click="resetForm">
              Cancel
            </v-btn>
            <v-slide-x-reverse-transition>
              <v-tooltip v-if="!valid" left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    class="my-0"
                    v-bind="attrs"
                    @click="resetForm"
                    v-on="on"
                  >
                    <v-icon>mdi-refresh</v-icon>
                  </v-btn>
                </template>
                <span>Refresh form</span>
              </v-tooltip>
            </v-slide-x-reverse-transition>
            <v-btn
              color="primary"
              :disabled="disabled"
              style="margin-right:20px;"
              @click="saveDO()"
            >
              <v-icon>mdi-floppy</v-icon>
              Save Rating
            </v-btn>
           <!-- <generate-charge-sheet-dialog v-if="isGenerate" /> -->
          </v-card-actions>
        </v-card>
      </v-col>
    </v-form>
  </v-container>
</template>

<script>
// const generateChargeSheetDialog = () => import("./dialog-charge-sheet");
import JwtService from "@/services/jwt.service";
import { createNamespacedHelpers } from "vuex";
import moment from "moment";
import {
  commonServices,
  portChargesCalculator
} from "@/services/common.services";
const departedVessel = createNamespacedHelpers("departed_vessels");
const deliveryOrderNamespace = createNamespacedHelpers("delivery_orders");
//const authModuleNamespace = createNamespacedHelpers("auth");

export default {
  components: {
   // generateChargeSheetDialog
  },
  data: () => ({
    valid: true,
    dialogDelete: false,
    isGenerate: false,
    activeItem: null,
    disabled: true,
    menu: null,
    cargo_no: null,
    cargo_type: null,
    do_id: null,
    vehicle_tonnage: null,
    cargo_size: null,
    cargo_description: null,
    seal_number: null,
    vin_number: null,
    item: [],
    item_index: -1,
    item_list: [],
    is_transit: false,
    is_reefer: false,
    tonnage_list: ["0-4999", "5000-9999", "10000+"],
    items: [20, 40, 45, 0],
    item_type: ["Full Container"],
    item_type_old: ["Full Container", "RoRo", "Bulk"],
    do_number: null,
    consignee_email: null,
    consignee_address: null,
    consignee_fullname: null,
    total_items: 0,
    weekends: 0,
    holidays: 0,
    departed_date: null,
    arrival_date: null,
    current_date: moment().format("YYYY-MM-DD"),
    total_charges: 0,
    waved_amount: 0,
    shore_handling: 0,
    waved_percentage: 0,
    hrs: 0,
    total_days_spend: 0,
    final_days_spend: 0,
    current_period: null,
    excluded_days: 0,
    do_detail: {
      number: null,
      do_number: null,
      bl_number: null,
      consignee_fullname: null,
      consignee_address: null,
      consignee_email: null,
      count_45ft: 0,
      count_40ft: 0,
      count_20ft: 0,
      count_vehicles: 0,
      item_quantity: null,
      updated_on: moment().format("YYYY-MM-DD"),
      delivery_authorised: 0
    },
    show: false,
    filteredList: null,
    search: "",
    nameRules: [
      v => !!v || "Name is required"
      // v => v.length <= 10 || "Name must be less than 10 characters"
    ],
    addressRules: [v => !!v || "Address is required"],
    textRules: [v => !!v || "Field is required"],
    inputRules: [
      v => (v || "").indexOf(" ") < 0 || "No spaces are allowed",
      v => !!v || "This field is required"
    ],
    email: "",
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+/.test(v) || "E-mail must be valid"
    ]
  }),
  watch: {
    holidays(val) {
      if (val) {
        this.excludeDays(this.holidays, this.weekends);
      }
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    weekends(val) {
      if (val) {
        this.excludeDays(this.holidays, this.weekends);
      }
    },
    total_charges(val) {
      if (val) this.disabled = false;
    }
  },

  computed: {
    ...departedVessel.mapState({
      loading: state => state.loading,
      vessel: state => state.selected_vessel
    }),
    ...deliveryOrderNamespace.mapState({
      //do_items: state => state.do_items,
      //do_details: state => state.do_details
      delivery_order: state => state.delivery_order
    }),
    /* ...authModuleNamespace.mapState({
      current_username: state => state.username
    }),*/
    current_username() {
      // console.log("current user", JwtService.getUser());
      return JwtService.getUser() ? JwtService.getUser()["username"] : " N/A";
    },
    header() {
      return [
        { text: "Cargo Number", value: "cargo_no" },
        { text: "Size", value: "cargo_size" },
        { text: "Type", value: "cargo_type" },
        { text: "Tonnage", value: "vehicle_tonnage" },
        { text: "VIN No.", value: "vin_number" },
        { text: "Seal Number", value: "seal_number" },
        { text: "Is Transit?", value: "is_transit" },
        { text: "Is Reefer?", value: "is_reefer" },
        { text: "Description", value: "cargo_description" },
        { text: "Action", value: "actions", align: "end", sortable: false }
      ];
    }
  },

  mounted() {
    this.departed_date = this.vessel.departure_date;
    this.arrival_date = this.vessel.arrival_date;
    //console.log("loading", this.loading);
  },
  methods: {
    ...deliveryOrderNamespace.mapActions(["asetDeliveryOrder"]),
    //
    doAction(item) {
      //
    },
    saveDO() {
      const do_details = {
        current_username: this.current_username ? this.current_username : null,
        do_info: this.do_detail,
        do_items: this.item_list,
        is_transit: this.is_transit,
        is_reefer: this.is_reefer,
        vessel_id: this.vessel.id,
        excludes: {
          holidays: this.holidays,
          weekends: this.weekends,
          final_days_spend: this.final_days_spend,
          total_days_spend: this.total_days_spend,
          total_days_excluded: this.excluded_days
        },
        charges: {
          total_charge: this.total_charges,
          amount_due: this.total_charges,
          shore_handling_amount: this.shore_handling,
          waved_amount: this.waved_amount,
          waved_percentage: this.waved_percentage
        }
      };

      if (do_details) {
        this.asetDeliveryOrder(do_details);
        this.commitData(do_details);
        //this.isGenerate = true;
      }

      //console.log("do data", do_details);
    },
    commitData(data) {
      if (data) {
        this.$store
          .dispatch("delivery_orders/addDeliveryOrder", data)
          .then(() => {
            this.$noty.success("Delivery Order Recorded!");
            this.isGenerate = true;
            this.disabled = true;
          })
          .catch(({ response }) => {
            this.errors = response.data;
          });

        //this.close();
      }
    },
    calculateCharges() {
      if (!this.$refs.form.validate()) {
        return;
      }
      //
      //let charges = 0.00;
      //this.total_charges = charges;
      //console.log("charges 1", this.departed_date);
      //console.log("charges 2", this.current_date);
      const excludes = {
        public_holidays: this.holidays,
        weekends: this.weekends
      };

      //set cargo count
      this.setCargoCount(this.item_list);

      const do_details = {
        do_number: this.do_detail.do_number,
        bl_number: this.do_detail.bl_number,
        consignee: this.do_detail.consignee_fullname,
        consignee_address: this.do_detail.consignee_address,
        item_quantity: this.do_detail.item_quantity,
        updated_on: this.do_detail.updated_on
      };

      //console.log("do details", do_details);
      //console.log("excludes ", excludes);

      this.total_days_spend = commonServices.getDaysSpend(
        this.departed_date,
        this.arrival_date,
        this.is_transit,
        this.current_date
      );

      if (this.total_days_spend >= this.excluded_days) {
        this.final_days_spend = this.total_days_spend - this.excluded_days;
      } else {
        this.final_days_spend = this.total_days_spend;
      }

      if (this.is_transit) {
        console.log("transit");
        const return_charges = portChargesCalculator(
          this.final_days_spend,
          this.hrs,
          "TRANSIT",
          this.cargo_type,
          this.item_list
        );

        const rent = return_charges.fee;
        this.shore_handling = return_charges.shore_handling;

        this.total_charges = rent
          ? rent // .toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")
          : 0;
      } else {
        console.log("local");
        const return_charges = portChargesCalculator(
          this.final_days_spend,
          this.hrs,
          "LOCAL",
          this.cargo_type,
          this.item_list
        );
        // console.log("charges", return_charges);
        const rent = return_charges.fee;
        this.shore_handling = return_charges.shore_handling;

        this.total_charges = rent
          ? rent //.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")
          : 0;
      }

      // console.log("charges 3", this.total_charges);
    },
    excludeDays(holidays, weekends) {
      let days;
      if (holidays && weekends) {
        days = parseInt(holidays) + parseInt(weekends);
      } else if (holidays) {
        days = parseInt(holidays);
      } else if (weekends) {
        days = parseInt(weekends);
      } else {
        days = 0;
      }
      //console.log("excluded days ", days);
      this.excluded_days = days;
    },
    removeItem(item) {
      this.item_index = this.item_list.indexOf(item);
      this.item_list.splice(this.item_index, 1);
      this.$noty.success("item removed...");
    },
    setCargoCount(cargo_list) {
      if (cargo_list) {
        let count_45ft = 0;
        let count_40ft = 0;
        let count_20ft = 0;
        let count_reefer = 0;

        for (let item in cargo_list) {
          if (cargo_list[item].cargo_size === 45) ++count_45ft;
          if (cargo_list[item].cargo_size === 40) ++count_40ft;
          if (cargo_list[item].cargo_size === 20) ++count_20ft;
          if (cargo_list[item].is_reefer) ++count_reefer;
        }

        this.do_detail.count_45ft = count_45ft;
        this.do_detail.count_40ft = count_40ft;
        this.do_detail.count_20ft = count_20ft;
      }
    },
    addItemsToDo() {
      const items = {
        do_id: this.do_id,
        cargo_no: this.cargo_no,
        cargo_type: this.cargo_type,
        cargo_size: this.cargo_size,
        seal_number: this.seal_number,
        vin_number: this.vin_number,
        is_transit: this.is_transit,
        is_reefer: this.is_reefer,
        hrs: this.hrs,
        vehicle_tonnage: this.vehicle_tonnage,
        cargo_description: this.cargo_description
      };

      if (!this.is_transit && !this.is_reefer) {
        if (!this.checkDOSanity(this.item_list, items.cargo_type)) {
          this.$noty.success("This action cannot be performed!");
          return;
        }
      }

      if (this.is_transit) {
        if (!this.transitCheck(this.item_list, items.is_transit)) {
          this.$noty.success("This action cannot be performed, TRANSIT ONLY!");
          return;
        }
      }

      if (this.is_reefer) {
        if (!this.reeferCheck(this.item_list, items.is_reefer)) {
          this.$noty.success("This action cannot be performed, REEFERS ONLY!");
          return;
        }
      }

      //
      if (items.cargo_no || items.vehicle_tonnage) {
        this.item_list.push(items);
        this.total_items = Object.keys(this.item_list).length;
        this.do_detail.item_quantity = Object.keys(this.item_list).length;
        // console.log(this.item_list);
      }

      //console.log(this.item_list);
      // console.log(items);
    },
    reeferCheck(item_list, type) {
      let exists = false;
      let count = 0;
      count = Object.keys(item_list).length;

      //console.log("count ", count);
      if (count != 0) {
        for (let item in item_list) {
          exists = item_list[item].is_reefer === type;
        }
        //console.log("exits", exists);
        if (exists) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    transitCheck(item_list, type) {
      let exists = false;
      let count = 0;
      count = Object.keys(item_list).length;

      //console.log("count ", count);
      if (count != 0) {
        //console.log("inside if", count);
        for (let item in item_list) {
          exists = item_list[item].is_transit === type;
        }
       // console.log("exits", exists);
        if (exists) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    checkDOSanity(item_list, cargo_type) {
      let exists = false;
      let exists_refeer = false;
      let exists_transit = false;
      let count = 0;
      count = Object.keys(item_list).length;

      //console.log("count ", count);
      if (count != 0) {
        for (let item in item_list) {
          exists = item_list[item].cargo_type === cargo_type;
          exists_refeer = item_list[item].is_reefer === true;
          exists_transit = item_list[item].is_transit === true;
        }
        //console.log("exits", exists);
        if (exists && !exists_refeer && !exists_transit) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    resetForm() {
      this.$refs.form.reset();
    }
  }
};
</script>

<style scoped>
.list {
  width: 100%;
}
</style>
